import React, { useState } from "react";
import CircularProgress from '@mui/joy/CircularProgress';
import axios from "axios";
import dayjs from 'dayjs';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BASE_URL } from '../../../constant/index';
import { useAuth } from "../../../context/AuthProvider";

const DataLoad = () => {
    const { token } = useAuth();
    const [ file, setFile ] = useState(null);
    const [ isLoading, setLoading ] = useState(false);
	const [ errorMsg, setErrorMsg ] = useState('');
    const [ sDate, setSelectedDate ] = useState(dayjs());
    const [ rows, setRows ] = useState(0);

    const handleFileChange = (e) => setFile(e.target.files[0]);

    const handleFileSubmit = async (e) => {
        e.preventDefault();
        try{
            setLoading(true);
            setErrorMsg('');

            if (!file) return alert("Please select a CSV file.");
      
            const formData = new FormData();
            formData.append('file', file);
      
            const { data } = await axios.post(BASE_URL + '/uploadCsv', formData, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data"
                },
            });
            setRows(data.count);
        } catch(err) {
            setErrorMsg(err?.response?.data?.reason);
        } finally {
            setLoading(false);
        }   
    };      

    const onDateSelection = (value) => {
        const selectedDate = dayjs(value).toDate();
        const formattedDate = dayjs(selectedDate).format('YYYY-MM-DD');
        setSelectedDate(formattedDate);
    }

    const handleGroup1 = async () => {
        try{
            setLoading(true);
            setErrorMsg('');

            const tradingDate = dayjs(sDate).format('YYYY-MM-DD');

            const config = {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
            };

            await Promise.all([
                axios.post(BASE_URL + '/pattern50MAVGP', { tradingDate }, config),
                axios.post(BASE_URL + '/pattern50MAVGN', { tradingDate }, config),
                axios.post(BASE_URL + '/pattern200MAVGP', { tradingDate }, config),
                axios.post(BASE_URL + '/pattern200MAVGN', { tradingDate }, config),
            ]);
            setLoading(false);
        } catch(err) {
            setErrorMsg('Server encountered an issue, please try later. If issue still persist, please reach out on help@capitaltrends.in');
			setLoading(false);
        }
    }
    
    const handleGroup2 = async () => {
        try{
            setLoading(true);
            setErrorMsg('');

            const tradingDate = dayjs(sDate).format('YYYY-MM-DD');

            const config = {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
            };

            await Promise.all([
                axios.post(BASE_URL + '/patternPR', { tradingDate }, config),
                axios.post(BASE_URL + '/patternNR', { tradingDate }, config),
                axios.post(BASE_URL + '/patternGU', { tradingDate }, config),
                axios.post(BASE_URL + '/patternGD', { tradingDate }, config),
            ]);
            setLoading(false);
        } catch(err) {
            setErrorMsg('Server encountered an issue, please try later. If issue still persist, please reach out on help@capitaltrends.in');
			setLoading(false);
        }
    }

    const handleGroup3 = async () => {
        try{
            setLoading(true);
            setErrorMsg('');

            const tradingDate = dayjs(sDate).format('YYYY-MM-DD');

            const config = {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
            };

            await Promise.all([
                axios.post(BASE_URL + '/patternGC', { tradingDate }, config),
                axios.post(BASE_URL + '/patternDC', { tradingDate }, config),
            ]);
            setLoading(false);
        } catch(err) {
            setErrorMsg('Server encountered an issue, please try later. If issue still persist, please reach out on help@capitaltrends.in');
			setLoading(false);
        }
    }

    const handleGroup4 = async () => {
        try{
            setLoading(true);
            setErrorMsg('');

            const tradingDate = dayjs(sDate).format('YYYY-MM-DD');

            const config = {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
            };

            await Promise.all([
                axios.post(BASE_URL + '/patternInsideDay', { tradingDate }, config),
                axios.post(BASE_URL + '/patternOutsideDay', { tradingDate }, config),
                axios.post(BASE_URL + '/pattern52WH', { tradingDate }, config),
                axios.post(BASE_URL + '/pattern52WL', { tradingDate }, config),
            ]);
            setLoading(false);
        } catch(err) {
            setErrorMsg('Server encountered an issue, please try later. If issue still persist, please reach out on help@capitaltrends.in');
			setLoading(false);
        }
    }

    const callPerfectAlignment = async () => {
        try{
            setLoading(true);
            setErrorMsg('');

            const tradingDate = dayjs(sDate).format('YYYY-MM-DD');
            await axios.post(BASE_URL+'/perfectAlignment', {
                tradingDate,
            } , {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                timeout: 30 * 60 * 1000
            });
            setLoading(false);
        } catch(err) {
            setErrorMsg('Server encountered an issue, please try later. If issue still persist, please reach out on help@capitaltrends.in');
			setLoading(false);
        }
    }

    const callPerfectAlignmentInverse = async () => {
        try{
            setLoading(true);
            setErrorMsg('');

            const tradingDate = dayjs(sDate).format('YYYY-MM-DD');
            await axios.post(BASE_URL+'/perfectAlignmentInverse', {
                tradingDate,
            } , {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                timeout: 30 * 60 * 1000
            });
            setLoading(false);
        } catch(err) {
            setErrorMsg('Server encountered an issue, please try later. If issue still persist, please reach out on help@capitaltrends.in');
			setLoading(false);
        }
    }

    const pattern52WVH = async () => {
        try{
            setLoading(true);
            setErrorMsg('');

            const tradingDate = dayjs(sDate).format('YYYY-MM-DD');
            await axios.post(BASE_URL+'/52WVHPattern', {
                tradingDate,
            } , {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                timeout: 30 * 60 * 1000
            });
            setLoading(false);
        } catch(err) {
            setErrorMsg('Server encountered an issue, please try later. If issue still persist, please reach out on help@capitaltrends.in');
			setLoading(false);
        }
    }

    const pattern3WTP = async () => {
        try{
            setLoading(true);
            setErrorMsg('');

            const tradingDate = dayjs(sDate).format('YYYY-MM-DD');
            await axios.post(BASE_URL+'/pattern3WTP', {
                tradingDate,
            } , {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                timeout: 30 * 60 * 1000
            });
            setLoading(false);
        } catch(err) {
            setErrorMsg('Server encountered an issue, please try later. If issue still persist, please reach out on help@capitaltrends.in');
			setLoading(false);
        }
    }

    const pattern5WTP = async () => {
        try{
            setLoading(true);
            setErrorMsg('');

            const tradingDate = dayjs(sDate).format('YYYY-MM-DD');
            await axios.post(BASE_URL+'/pattern5WTP', {
                tradingDate,
            } , {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                timeout: 30 * 60 * 1000
            });
            setLoading(false);
        } catch(err) {
            setErrorMsg('Server encountered an issue, please try later. If issue still persist, please reach out on help@capitaltrends.in');
			setLoading(false);
        }
    }

    const patternUp5W = async () => {
        try{
            setLoading(true);
            setErrorMsg('');

            const tradingDate = dayjs(sDate).format('YYYY-MM-DD');
            await axios.post(BASE_URL+'/patternUp5W', {
                tradingDate,
            } , {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                timeout: 30 * 60 * 1000
            });
            setLoading(false);
        } catch(err) {
            setErrorMsg('Server encountered an issue, please try later. If issue still persist, please reach out on help@capitaltrends.in');
			setLoading(false);
        }
    }

    return (
        <>
            <div className="container">
                {
                    errorMsg && (
                        <Stack sx={{ width: '100%', marginTop: '10px' }} spacing={2}>
                            <Alert severity="error">{errorMsg}</Alert>
                        </Stack>
                    )
                }

                <div className="container">
                    <div className="row">
                        <div className="col-12" style={{ paddingBottom: 15 }}>
                            <b>Step 1 - </b>Download both files from NSE website (
                                <a href="https://www.nseindia.com/all-reports" target="_blank" rel="noopener noreferrer">https://www.nseindia.com/all-reports</a>
                                )
                        </div>
                        <div className="col-12">
                            <b>Step 2 - </b>Upload files here one by one, make sure the format remain same: <b>sec_bhavdata_full_xxx</b> && <b>ind_close_all_xxx</b>
                        </div>
                        <div className="col-12" style={{ paddingTop: 15, paddingBottom: 15 }}>
                            <form onSubmit={handleFileSubmit}>
                                <input type="file" accept=".csv" onChange={handleFileChange} />
                                <button type="submit" className="btn mdb-button-width btn-outline-primary">Upload & Process</button>
                            </form>
                        </div>
                        {
                            rows > 0 && (
                                <Stack sx={{ width: '100%', marginTop: '10px', marginBottom: '10px' }} spacing={2}>
                                    <Alert severity="success">Rows processed: {rows}</Alert>
                                </Stack>
                            )
                        }
                        <hr/>
                        <div className="col-12" style={{ paddingBottom: 25 }}>
                            <b>Step 3- </b>Click on below buttons to process the data. Please note that this will take time depending on the data size. Please note by default
                            it will take the last trading date, if you want to process for any other date, please select the date from below.
                        </div>
                        <div className="col-4">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker 
                                    label="Date"
                                    value={dayjs(sDate)}
                                    onChange={(newValue) => onDateSelection(newValue)}
                                    slotProps={{
                                        textField: {
                                        helperText: 'YYYY-MM-DD',
                                        },
                                    }}
                                    maxDate={dayjs()}
                                    format="YYYY-MM-DD"
                                />
                            </LocalizationProvider>    
                        </div>
                    </div>
                    {
                        isLoading ? (
                            <div className="loader-container">
                                <CircularProgress size="lg" />
                            </div>
                        ) : (
                            <>
                                <div className="row">
                                    <div className="col-12">
                                        <h3 className="page-subtitle-master">Daily Patterns</h3>
                                        <div className="md-links-prs" style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 0.6fr)', gap: '3px' }}>
                                            <button 
                                                onClick={() => handleGroup1()} 
                                                className="btn mdb-button-width btn-outline-primary"
                                            >
                                                50 & 200 MAVG
                                            </button>
                                            <button 
                                                onClick={() => handleGroup2()} 
                                                className="btn mdb-button-width btn-outline-primary"
                                            >
                                                PR, NR, GU, GD
                                            </button>
                                            <button 
                                                onClick={() => handleGroup3()} 
                                                className="btn mdb-button-width btn-outline-primary"
                                            >
                                                GC, DC
                                            </button>
                                            <button 
                                                onClick={() => handleGroup4()} 
                                                className="btn mdb-button-width btn-outline-primary"
                                            >
                                                ID, OD, 52Wh, 52WL
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-12">
                                        <h3 className="page-subtitle-master">Weekly Patterns</h3>
                                        <div className="md-links-prs" style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 0.6fr)', gap: '3px' }}>
                                            <button 
                                                onClick={() => pattern3WTP()} 
                                                className="btn mdb-button-width btn-outline-primary"
                                            >
                                                3WTP
                                            </button>

                                            <button 
                                                onClick={() => pattern5WTP()} 
                                                className="btn mdb-button-width btn-outline-primary"
                                            >
                                                5WTP
                                            </button>

                                            <button 
                                                onClick={() => patternUp5W()} 
                                                className="btn mdb-button-width btn-outline-primary"
                                            >
                                                UP5W
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <hr/>
                                <div className="row">
                                    <div className="col-12">
                                        <h3 className="page-subtitle-master">Admin Patterns</h3>
                                        <div className="md-links-prs" style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 0.6fr)', gap: '3px' }}>
                                            <button 
                                                onClick={() => callPerfectAlignment()} 
                                                className="btn mdb-button-width btn-outline-primary"
                                            >
                                                Perfect Alignment
                                            </button>

                                            <button 
                                                onClick={() => callPerfectAlignmentInverse()} 
                                                className="btn mdb-button-width btn-outline-primary"
                                            >
                                                Perfect Inverse Alignment
                                            </button>

                                            <button 
                                                onClick={() => pattern52WVH()} 
                                                className="btn mdb-button-width btn-outline-primary"
                                            >
                                                52WVH
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    }
                </div>
            </div>
        </>
    )

}

export default DataLoad;